import { toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, mergeProps as _mergeProps, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "font-weight-medium" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ontos_count = _resolveComponent("ontos-count")!
  const _component_ontos_header_action = _resolveComponent("ontos-header-action")!
  const _component_v_checkbox_btn = _resolveComponent("v-checkbox-btn")!
  const _component_v_list_item_action = _resolveComponent("v-list-item-action")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_ontos_colored_value = _resolveComponent("ontos-colored-value")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_menu = _resolveComponent("v-menu")!

  return (_openBlock(), _createBlock(_component_v_menu, {
    location: "bottom end",
    "close-on-content-click": false
  }, {
    activator: _withCtx(({props}) => [
      _createVNode(_component_ontos_header_action, _mergeProps({
        icon: _ctx.icon,
        label: _ctx.label,
        title: _ctx.summary
      }, props), {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.label) + " ", 1),
          _createVNode(_component_ontos_count, {
            count: _ctx.modelValue.length,
            hidden: _ctx.hiddenCount
          }, null, 8, ["count", "hidden"])
        ]),
        _: 1
      }, 16, ["icon", "label", "title"])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_v_list, {
        density: "compact",
        class: "py-0"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_list_item, {
            class: "check-menu-option",
            disabled: _ctx.allLocked,
            onClick: _ctx.toggleAll
          }, {
            prepend: _withCtx(() => [
              _createVNode(_component_v_list_item_action, { start: "" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_checkbox_btn, {
                    "model-value": _ctx.allChosen,
                    indeterminate: _ctx.someChosen,
                    disabled: _ctx.allLocked
                  }, null, 8, ["model-value", "indeterminate", "disabled"])
                ]),
                _: 1
              })
            ]),
            default: _withCtx(() => [
              _createElementVNode("span", _hoisted_1, _toDisplayString(_ctx.$tt('all')), 1)
            ]),
            _: 1
          }, 8, ["disabled", "onClick"]),
          _createVNode(_component_v_divider),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item) => {
            return (_openBlock(), _createBlock(_component_v_list_item, {
              key: item.value,
              class: _normalizeClass(['check-menu-option', {'check-menu-option--tinted': !!_ctx.hoverColor}, item.class]),
              style: _normalizeStyle(_ctx.hoverColor ? {'--check-menu-hover': _ctx.hoverColor} : undefined),
              disabled: _ctx.isLocked(item),
              onClick: ($event: any) => (_ctx.toggle(item.value))
            }, {
              prepend: _withCtx(() => [
                _createVNode(_component_v_list_item_action, { start: "" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_checkbox_btn, {
                      "model-value": _ctx.modelValue.includes(item.value),
                      color: item.color,
                      disabled: _ctx.isLocked(item)
                    }, null, 8, ["model-value", "color", "disabled"])
                  ]),
                  _: 2
                }, 1024)
              ]),
              default: _withCtx(() => [
                (item.option && item.form)
                  ? (_openBlock(), _createBlock(_component_ontos_colored_value, {
                      key: 0,
                      option: item.option,
                      form: item.form
                    }, null, 8, ["option", "form"]))
                  : (_openBlock(), _createElementBlock("span", {
                      key: 1,
                      class: _normalizeClass(item.labelClass)
                    }, _toDisplayString(item.title), 3))
              ]),
              _: 2
            }, 1032, ["class", "style", "disabled", "onClick"]))
          }), 128))
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}